import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'

import configureStore from './redux/configureStore'

import App from './components/app'
import LoginPage from './components/Account/Login/LoginComponent'
import ForgotPassword from './components/Account/Forgot/ForgotComponent'
import NewPassword from './components/Account/Reset/ResetComponent'
import ListPatients from './components/Search/SearchComponent'
import ListUsers from './components/SearchUser/UserSearchComponent'
import ListEps from './components/EPS/SearchEps/SearchComponent'
import ListType from './components/Type/SearchType/SearchComponent'
import ListGroup from './components/Group/SearchGroup/SearchComponent'
import Percentil from './components/Patient/Percentil'
import Health from './components/Health/HealthForm'
import Patient from './components/Patient/PatientComponent'
import User from './components/User/UserComponent'
import Eps from './components/EPS/EpsComponent'
import Type from './components/Type/TypeComponent'
import Reportes from './components/Reportes/Reporte'
import Group from './components/Group/GroupComponent'
import Medical from './components/Patient/MedicalForm'
import SuperMedical from './components/Patient/SuperMedicalForm'
import SuperDiabetes from './components/Patient/SuperDiabetesForm'
import Squares from './components/Patient/PatientMedicalSquares'
import EstadoSaludSquares from './components/Patient/PatientMedicalSquaresEstadoSalud'
import Dashboard from './components/Dashboard/DashboardComponent'
import EstadoSaludDashboard from './components/EstaDoSaludDashboard/DashboardComponent'
import ViewStatics from './components/ViewStatics/ViewStatics'
import TableData from './components/HealthTable/TableData'
import PrintableDiabetes from './components/PrintableDiabetes/PrintableDiabetes'
import PrintableDashboard from './components/PrintableDashboard/DashboardComponent'
import { Router, Route, hashHistory, IndexRoute } from 'react-router'
import './css/main.css'

const STORE = configureStore()
render((
    <Provider store={STORE}>
      <Router history={hashHistory}>
        <Route path='/' component={App}>
          <IndexRoute component={LoginPage} />
          <Route path='forgot' component={ForgotPassword}/>
          <Route path='reset/:token' component={NewPassword}/>
          <Route path='search' component={ListPatients}/>
          <Route path='searchUser' component={ListUsers}/>
          <Route path='searchEps' component={ListEps}/>
          <Route path='searchType' component={ListType}/>
          <Route path='searchGroup' component={ListGroup}/>
          <Route path='patient' component={Patient}/>
          <Route path='user' component={User}/>
          <Route path='eps' component={Eps}/>
          <Route path='type' component={Type}/>
          <Route path='reportes' component={Reportes}/>
          <Route path='group' component={Group}/>
          <Route path='medicalSquares/:patient' component={Squares}/>
          <Route path='patient/:patient' component={Patient} />
          <Route path='user/:user' component={User} />
          <Route path='eps/:eps' component={Eps}/>
          <Route path='type/:type' component={Type}/>
          <Route path='group/:group' component={Group}/>
          <Route path='medical/:patient' component={Medical}/>
          <Route path='superMedical/:patient' component={SuperMedical}/>
          <Route path='superDiabetes/:patient' component={SuperDiabetes}/>
          <Route path='tabledata/:patient' component={TableData}/>
          <Route path='dashboard/:patient' component={Dashboard}/>
          <Route path='estadoSaludDashboard/:patient' component={EstadoSaludDashboard}/>
          <Route path='ViewStatics' component={ViewStatics}/>
          <Route path='printableDashboard/:patient' component={PrintableDashboard}/>
          <Route path='printableDiabetes/:patient' component={PrintableDiabetes}/>
          <Route path='percentil/:id/:health/:patient' component={Percentil}/>
          <Route path='health/:patient' component={Health}/>
        </Route>
      </Router>
    </Provider>
), document.getElementById('app'))



// WEBPACK FOOTER //
// ./src/index.js